/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PR.vue?vue&type=template&id=42211dbf&"
import script from "./PR.vue?vue&type=script&lang=js&"
export * from "./PR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports